import React, { useState,useEffect,useMemo } from 'react';
import {Box,Typography,Grid} from '@mui/material';
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import DyDataGridCustom from '../../../../components/GlobalComponents/DYCustom1/DYCustom1';
import { useGetAlignmentMeetingDetailsByMeetingId,useGetAllAlignmentMeetingsByTenantId } from '../../Hooks/Index';
// import { ReactComponent as AddMeetingVector } from "../../AddMeetingSuccessVector.svg";
import{useNavigate} from 'react-router-dom';
import { NewUseStore } from '../../../../Store/newUseStore';
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import AlignmentCart from '../AlignmentCart/AlignmentCart';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import AddAlignmentMeeting from '../Forms/AddMeeting/AddAlignmentMeeting';
// import { useGetAllCooperate } from '../../../OKRManagment/Hooks';
// import MyMeetingCard from '../../../Meeting/MyMeetingCard/MyMeetingCard';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import EditAlignmentMeeting from '../Forms/AddMeeting/EditAlignmentMeeting';
import LoadingSpinner from '../../../../components/Progress/LoadingSpinner';

export const AllAlignmentMeeting = ({periodsData, periodId}:any) => {
    const updateNewCompanyId = NewUseStore((state) => state.updateNewCompanyId);
    // const[showDownloadLink,setShowDownlodLink]=useState<boolean>(false)
    const[meetId,setMeetId]=useState<any>('');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه

    const[showToastMessage,setShowToastMessage]=useState<boolean>(false);
    const[meetingAsyncState,setMeetingAsyncState]=useState<any|null>(null);
    // const [createTenantModal,setCreateTenantModal]=useState<boolean>(false);
    const navigate=useNavigate();
    const getDetSuccess = (data: any) => {
      if(data === undefined || data === null || 
        (data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos === null &&
        data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos === null)
      ){
        setMeetingAsyncState({
          isSuccess: false,
          metaData: { message: "درخواست یا پیشنهادی در جلسه مورد نظر وجود ندارد" },
        });
        setShowToastMessage(true);
      }
        else
      if (
        (data &&
          data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos &&
          data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos.length >
            0) ||
        (data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos &&
          data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos.length >
            0)
      ) {
        const id =
          data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos &&
          data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos.length > 0
            ? data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos[0].id
            : data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos[0].id;
        updateNewCompanyId(id);
        navigate("/alignmentCompanyTeams");
      } else {
        setMeetingAsyncState({
          isSuccess: false,
          metaData: { message: "اطلاعاتی برای نمایش وجود ندارد" },
        });
        setShowToastMessage(true);
      }
    };
    const getDetFailed=()=>{
  
    }
    
    const profileTenantId=useSelector((state:any)=>state.meetings.profileTenantId);
    const{data:MeetDetData,isLoading:meetLoading,refetch:getAgain}
    =useGetAlignmentMeetingDetailsByMeetingId(getDetSuccess,getDetFailed,meetId);
  //  const {data:dataIndex,isLoading:dataLoading1,isError:dataError1}
  //  =useGetAllCooperate(periodId,profileTenantId);
    // const profileTenantId = NewUseStore((state) => state.newTenantId);

    // const priodId=useSelector((state:any)=>state.meetings.priodId);
    // const periodList=useSelector((state:any)=>state.meetings.periodList);
    // let priodId = useSelector((state: any) => state.meetings.priodId);
    // if (priodId === '' || priodId === null || priodId === undefined) {
    //   const x = periodList.filter((x : any)=>x.isCurrent === true);
    //   const xx = x[0]
    //   let {id} = xx;
    //   priodId=id;
    // }
    const userPhoneNumber:string=useSelector((state:any)=>state.loign.userPhoneNumber);
    const{isLoading:meetLoadin,data:meetdata,isFetched,refetch: getAgain1}
    =useGetAllAlignmentMeetingsByTenantId({tenantId:profileTenantId,priodId:periodId,userPhoneNumber:userPhoneNumber})

    const [existData,setExistData]=useState<any>(null);
    const [indexSelectionModel, setIndexSelectionModel] = useState<string | any>(
      localStorage.getItem("indexSelectionModel")
    );
    const [accessForReport,setAccessForReport]=useState<boolean>(false);
    const [krId, setKrId] = useState('');
    const [Ids, setIds] = useState(null);
    const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
    const [createTenantModal, setCreateTenantModal] = useState<boolean>(false);
    const [bank,setBank]=useState<boolean>(false);
    const [krRowData, setKrRowData] = useState(null);
    const[meetingLenght,setMeetingLenght]=useState<Number>(0);
    // const[reloadMeetingData,setReloadMeetingData]=useState<boolean>(false);
    const [showEditMeeting,setshowEditMeeting]=useState<boolean>(false);
    const [meetingId,setMeetingId]=useState<string|null>(null);
    
    useEffect(() => {
      if (meetdata) {
        let{accessibleForReport}=meetdata;
        setAccessForReport(accessibleForReport)
      }
    },[meetdata]);

    useEffect(() => {
      if (meetdata) {
        let{bank}=meetdata;
        setBank(bank)
      }
    },[meetdata]);

       useEffect(() => {
         if (meetdata) {
        setExistData(meetdata.meetingsList)
        setMeetingLenght(meetdata.length)
         }
       }, [meetdata]);  
  
       const initialCreateMeeting=()=>{
        setCreateTenantModal(!createTenantModal)
       }

    if (meetLoadin || existData===null || isFetched!==true) {
      return <Box display={'flex'} 
      alignItems={'center'} 
      justifyContent={'center'} 
      width={'100%'} 
      height={'500px'} 
      boxShadow={4} borderRadius={3}>
        <LoadingSpinner  />
       </Box>
    }
  
    return (
      <Grid container  spacing={1} >
        <Grid item xs={12}>
        <Box display={"flex"} flexDirection={"row-reverse"}>
        <Box display={"flex"} flexDirection={"row-reverse"} py={1} px={2}>
            <DyButton
              caption={"ایجاد جلسه"}
              color={"#00l387C"}
              // onClick={loginHandler}
              disbled={false}
              variant={"contained"}
              bgColor={"#00387C"}
              onClick={initialCreateMeeting}
              // type={'submit'}
            />
          </Box>
        </Box>
      </Grid>

        {/* <Grid item xs={12}    >
                       <Box display={'flex'}  flexDirection={'row-reverse'}>
                      <Box width={'100%'}   >
                      {
                        renderContent()
                      }
                      </Box>
                       </Box>
        </Grid> */}
     {
         existData && existData?.map((data:any,i:number):any=>{
          return (
          <Grid item md={4} xs={12}  key={i}>
            <Box
                key={i}
                sx={{
                    transition: "all 0.3s ease",
                    "&:hover": {
                    transform: "scale(1.05)",
                    backgroundColor: "withesmoke",
                    // boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
                    // borderRadius: "12px",
                    },
                    padding: "10px", // Add padding to ensure content isn't cut off during hover
                }}>
            <AlignmentCart 
            setMeetId={setMeetId}
            info={data}
            prog={i}  
            accessForReport={accessForReport}
            bank={bank}
            // setShowDownlodLink={setShowDownlodLink}
            setPMeetingId={setMeetingId}
            setshowEditMeeting={setshowEditMeeting}
            setShowToastMessage={setShowToastMessage}
            setDeleteMeetState={setMeetingAsyncState}
            showEditMeeting={showEditMeeting}
             />
            </Box> 
            </Grid>)
        })
     }

    {
      existData?.length===0 && <Box sx={{ display: 'flex',alignItems:'center',justifyContent:'center',height:'100%',width:'100%' }}>
        <Grid item xs={12}>
         <div className="w-full flex justify-center">
          {/* <Box alignSelf={"center"} textAlign={"center"}> */}
          <Typography fontSize={20}>
            {/* <AddMeetingVector
              style={{
                width: "300px",
                height: "100%",
                alignSelf: "center",
                textAlign: "center",
              }}
              /> */}
                در این دوره جلسه ایی وجود ندارد
              </Typography>
              </div>
          {/* </Box> */}
        </Grid>
      
      </Box>
    } 
    
    {createTenantModal && (
        <ModalLyt
          title={"ایجاد جلسه"}
          height={700}
          width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
          showModal={Boolean(createTenantModal)}
          setShowModal={setCreateTenantModal}
        >
          {/* showToastMessage,setShowToastMessage */}
          <AddAlignmentMeeting
            // meetingLenght={meetingLenght}
            hideModal={setCreateTenantModal}
            periodId={periodId}
            setMeetingAsyncState={setMeetingAsyncState}
            setShowToastMessage2={setShowToastMessage2}
            profileTenantId={profileTenantId}
            onSuccess={getAgain1}
            onClose={setCreateTenantModal}
            // setReloadMeetingData={setReloadMeetingData}
          />
        </ModalLyt>
      )}

     {showEditMeeting && (
        <ModalLyt 
          showModal={showEditMeeting} 
          setShowModal={setshowEditMeeting}           
          width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
        >
          <EditAlignmentMeeting
            meetingId={meetingId}
            hideModal={setshowEditMeeting}
            setMeetingAsyncState={setMeetingAsyncState}
            setShowToastMessage={setShowToastMessage}
            profileTenantId={profileTenantId}
          />
        </ModalLyt>
      )}

    {showToastMessage && (
        <DYToastMessage
          isSuccess={meetingAsyncState?.isSuccess}
          message={meetingAsyncState?.metaData.message}
          setShow={setShowToastMessage}
          show={showToastMessage}
        />
      )}
       {showToastMessage2 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage2}
            show={showToastMessage2}
          />
        )}
      </Grid>
    )
  }